module.exports = __webpack_public_path__ + "img/四川天府新区童欣幼儿园.5be13c8b.jpg";